import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useGetAuth, useSetAuth } from '../hooks/useAuth';
import { privileged } from '../constants/config';

export default function ValidateAuth() {
  const params = useParams();
  const navigate = useNavigate();
  const { isLoading, isError, data, error } = useGetAuth(params.token);

  useSetAuth(data);

  useEffect(() => {
    if (!isLoading && data) {
      privileged.includes(data.data.data.attributes.role) ? navigate('/admin') : navigate('/dashboard');
    }
  }, [isLoading]);

  return (
    <div>Logging in...</div>
  )
}
